var scope_0 = require('/tmp/7465f8d3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0caadcc9a287fc6317460783cd119781.js').default;
var scope_1 = require('/tmp/7465f8d3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/tmp/7465f8d3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33eb0c1766ed8fa8a7e81e22db72028f.js').default;
var scope_3 = require('/tmp/7465f8d3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/52f8c2554ae1c0ba693934b82f0126a3.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    